import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import { theme } from 'helpers/Theme/';
import {
  formatSellerAnalyticsGraphLabels,
  formatSellerAnalyticsGraphValues,
} from 'helpers/formatting';
import { PlotValue } from 'types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
);

function SellerAnalyticsAreaChart({
  data,
  labelText,
}: {
  data: PlotValue[];
  labelText: string;
}) {
  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        padding: 8,
        titleFont: {
          size: 12,
        },
        bodyFont: {
          size: 10,
        },
        callbacks: {
          label: function (context: any) {
            let label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }

            if (context.parsed.y !== null) {
              label += `${context.parsed.y} ${labelText}`;
            }
            return label;
          },
        },
      },
    },
  };

  const labels = formatSellerAnalyticsGraphLabels(data);

  const values = formatSellerAnalyticsGraphValues(data);

  const dataSet = {
    labels,
    datasets: [
      {
        fill: true,
        data: values,
        borderColor: theme.colors.BLUE,
        backgroundColor: `rgba(102, 204, 255, 0.31)`,
      },
    ],
  };

  return <Line data={dataSet} options={options} />;
}

export { SellerAnalyticsAreaChart };
